<template>
  <div class="invoice">
    <re-dialog title="选择地址" :visible.sync="visible" width="1400px">
      <div slot="title" class="fr ac jsb head">
        <p class="fz14 black bold">选择地址</p>
        <i class="el-icon-close fz14 cursor" @click="visible = false"></i>
      </div>
      <el-table
          border
          :data="address_list"
          ref="singleTable"
          max-height="400"
          header-align="center"
          v-infinite-scroll="getMemberAddress"
          infinite-scroll-disabled="finished"
          style="width: 100%"
          highlight-current-row
          @row-click="showRow"
      >
        <el-table-column label="操作" width="70" align="center">
          <template slot-scope="scope">
            <el-radio class="radio" v-model="radio" :label="scope.row.address_id">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column label align="center" width="90">
          <template slot-scope="scope">
            <el-tag type="success" size="small" v-if="scope.row.is_default == '1'">默认地址</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="address_name" label="收件人姓名" align="center" width="100"></el-table-column>
        <el-table-column label="联系方式" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ formatPhone(scope.row.address_mobile) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="地址类型" align="center" width="120">
          <template slot-scope="scope">
            <el-tag type="primary" size="small" v-show="scope.row.address_type.indexOf('1') !== -1">收货</el-tag>
            <el-tag type="success" size="small" v-show="scope.row.address_type.indexOf('2') !== -1">发票</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="省" align="center" prop="address_province" width="100"/>
        <el-table-column label="市" align="center" prop="address_city" width="100"/>
        <el-table-column label="区" align="center" prop="address_country" width="100"></el-table-column>
        <el-table-column label="详情地址" align="center" prop="address_detailed"></el-table-column>
        <el-table-column prop="invoice_name" label="操作" align="center" width="160">
          <template slot-scope="scope">
            <el-button type="text" @click.stop="editAddress(scope.row)">修改地址</el-button>
            <el-button type="text" @click.stop="deleteAddress(scope.row.address_id)">删除地址</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="fr ac jc mt20" slot="footer">
        <el-button type="primary" style="width:100px" @click="submit">确认</el-button>
        <el-button type="primary" style="width:100px" @click="editAddress({})">新增地址</el-button>
      </div>
    </re-dialog>
    <!-- 添加地址 -->
    <add-address
        type="edit"
        :company_id="$props.company_id"
        :addressVisible.sync="address_show"
        :info="address_json"
        @success="handleSuccess"
    />
  </div>
</template>

<script>
import AddAddress from "@/components/HandleAddress";

export default {
  components: {AddAddress},
  props: {
    addressvisible: {
      type: Boolean,
      default: false
    },
    address_id: Number,
    company_id: String
  },
  data() {
    return {
      address_json: {},
      radio: null,
      visible: false,
      address_list: [], //发票
      page: 1, //发票页数
      finished: false, //发票是否加载完成
      address_show: false,
    };
  },
  watch: {
    addressvisible(n) {
      this.visible = n;
      if (n) {
        this.handleSuccess();
      }
      this.radio = this.address_id;
    },
    address_id(n) {
      this.radio = n;
    },
    company_id(n) {
      this.getMemberAddress();
    },
    visible(n) {
      this.$emit("update:addressvisible", n);
    }
  },
  methods: {
    deleteAddress(address_id) {
      this.$confirm('此操作将永久删除该地址, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.post("addressInterfaces/v1.0/deleteAddress", {address_id}).then(res => {

          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.page = 1;
          this.finished = false;
          this.getMemberAddress();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    editAddress(row) {
      this.address_json = row;
      this.address_show = true;
    },
    handleSuccess() {
      this.page = 1;
      this.finished = false;
      this.getMemberAddress();
    },
    // 获取地址。
    getMemberAddress() {
      if (this.is_Empty(this.company_id) && this.hasMemberType(4)) {
        return;
      }
      if (this.finished) return;
      let obj = {
        page: this.page
      };
      if (this.company_id) {
        obj.company_id = this.company_id;
      }
      this.post("addressInterfaces/v1.0/getMemberAddress", obj).then(res => {
        if (res.status === "ok") {
          let arr = res.data;
          if (this.is_Empty(this.address_json)) {
            arr.forEach(el => {
              if (el.address_id === this.radio) {
                this.address_json = el;
              }
            })
          }
          if (obj.page > 1) {
            arr = this.address_list.concat(arr)
          }
          this.address_list = arr;
          this.finished = this.address_list >= res.total;
          this.page++;
        }
      });
    },
    showRow(row) {
      this.address_json = row;
      this.radio = row.address_id;
    },
    submit() {
      this.$emit("selectAddress", this.address_json);
      this.visible = false;
    }
  }
};
</script>

<style scoped lang="scss">
.invoice {
  .address_title {
    width: 10%;
  }

  .el-dialog {
    .el-dialog__header {
      background-color: #eaeaea;
      height: 40px;
      padding: 0 20px;

      .head {
        height: 100%;
      }
    }
  }

  .el-table {
    // max-height: 400px;
    overflow-y: scroll;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SelectAddress.vue